export enum TooltipPosition {
  TOP = 'top',
  TOP_START = 'top-start',
  TOP_END = 'top-end',
  BOTTOM = 'bottom',
  BOTTOM_START = 'bottom-start',
  BOTTOM_END = 'bottom-end',
  LEFT = 'left',
  LEFT_START = 'left-start',
  LEFT_END = 'left-end',
  RIGHT = 'right',
  RIGHT_START = 'right-start',
  RIGHT_END = 'right-end',
}

export type TooltipOffset = {
  mainAxis?: number;
  crossAxis?: number;
};

export const TooltipSize = {
  Md: 'md',
  Sm: 'sm',
} as const;

export type TooltipSizeType = (typeof TooltipSize)[keyof typeof TooltipSize];

export type TooltipProps = {
  id?: string;
  position?: TooltipPosition;
  offset?: TooltipOffset;
  title?: string;
  description?: string;
  openDelay?: number;
  interactive?: boolean;
  size?: TooltipSizeType;
  tooltipTriggerClass?: string;
};
